import { useTranslation } from "react-i18next";
import ReactTimeago from "react-timeago-i18n";

function Timeago({ date, allowFuture }) {
  // Follow the active UI language so "2 months ago" localizes (e.g. German "vor 2 Monaten")
  // instead of always rendering English.
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";
  return date ? (
    <ReactTimeago locale={lang} date={date} allowFuture={allowFuture} />
  ) : null;
}

export default Timeago;
